define('app/models/ResultSet',['require','glu/util','app/visualizations/FormatFactory','glu/collection'],function(require) {
	'use strict';

	var _ = require('glu/util'),
		FormatFactory = require('app/visualizations/FormatFactory'),
		Collection = require('glu/collection');

	// TODO: Upgrade Underscore so we get this function
	_.negate = _.negate || function(predicate) {
		return function() {
			return !predicate.apply(this, arguments);
		};
	};


	var headerHash = function(header) {
		var fieldId = !header.fieldId && header.name === 'primaryColumn' ? 'primaryColumn' : header.fieldId;

		if (header.function) {
			fieldId = header.function;
			_.each(header.funcArguments, function(argument) {
				fieldId = fieldId + '_' + argument.fieldId;
			});
		}

		if (header.segmentId) {
			fieldId = header.segmentId;
		}

		return 'column_' + fieldId + (header.aggregation ? '_' + header.aggregation : '');
	};

	var LEFT_FIRST = -1,
		RIGHT_FIRST = 1,
		EQUAL = 0;

	var ascendingCaseInsensitiveComparator = function(a, b) {

		if (typeof a === 'string' && typeof b === 'string') {
			a = a.toUpperCase();
			b = b.toUpperCase();
		}


		if (a < b) {
			return LEFT_FIRST;
		}

		if (a > b) {
			return RIGHT_FIRST;
		}

		if (a === null) {
			a = undefined;
		}

		if (b === null) {
			b = undefined;
		}

		if (a === undefined && b !== undefined) {
			return LEFT_FIRST;
		}

		if (a !== undefined && b === undefined) {
			return RIGHT_FIRST;
		}

		return EQUAL;
	};

	var descendingCaseInsensitiveComparator = function(a, b) {
		return ascendingCaseInsensitiveComparator(b, a);
	};

	var comparator = function(direction) {
		if (direction && direction.toLowerCase() === 'desc') {
			return descendingCaseInsensitiveComparator;
		} else {
			return ascendingCaseInsensitiveComparator;
		}
	};

	return function(data) {

		var self = this;

		var isAggregated = function(header) {
			return header.aggregation !== undefined || header.columnType === 'COUNT';
		};

		var isColumnAtIndexConsideredAMeasure = _.some(data.header, isAggregated) ? function(index) {
			return isAggregated(data.header[index]);
		} : function(index) {
			return data.header[index].isMeasure === true;
		};

		var isColumnAtIndexConsideredACategory = _.negate(isColumnAtIndexConsideredAMeasure);

		var groupedColumnIndexes;

		var findGroupedColumnIndexes = function() {
			groupedColumnIndexes = _.chain(data.header).map(function(header, index) {
				if (isColumnAtIndexConsideredACategory(index)) {
					return index;
				}
			}).filter(function(index) {
				return index !== undefined;
			}).value();
		};

		findGroupedColumnIndexes();

		var measureColumnIndexes;

		var findMeasureColumnIndexes = function() {
			measureColumnIndexes = _.chain(data.header).map(function(header, index) {
				if (isColumnAtIndexConsideredAMeasure(index)) {
					return index;
				}
			}).filter(function(index) {
				return index !== undefined;
			}).value();
		};

		findMeasureColumnIndexes();

		//TODO: remove-me : API should be fixed
		// work around the API returning the wrong type in some cases
		var actualType = function(header) {
			if (header) {
				if (header.aggregation === 'COUNT' || header.aggregation === 'COUNTD') {
					return 'INT';
				}
				if (header.fieldType === 'TIMESPAN' && (header.aggregation === 'AVG' || header.aggregation === 'STDDEV' || header.aggregation === 'MEDIAN')) {
					return 'TIMESPAN';
				}
				if (header.type === 'INT' && (header.aggregation === 'AVG' || header.aggregation === 'STDDEV' || header.aggregation === 'MEDIAN')) {
					return 'DEC';
				} else {
					return header.type || 'unspecified';
				}
			}
		};

		var formatOptions = function(header) {
			if (header) {
				var result = {
					enumeration: header.enumeration,
					aggregation: header.aggregation,
					displayFormat: header.displayFormat
				};
				if (header.isPercentage) {
					result.percentage = {
						total: header.total
					};
				}
				return result;
			}
		};

		this.translateHeader = function(header) {
			if (header) {
				var result = {
					label: header.name,
					title: header.title,
					field: headerHash(header),
					metadata: header,
					sorted: 'desc'
				};

				if (header.sort) {
					result.sort = true;
					result.sorted = (header.sort.priority === self.firstSortPriority()) ? header.sort.order.toLowerCase() : null;
				}

				result.format = FormatFactory.formatterForType(actualType(header), formatOptions(header));

				result.className = 'dt-' + actualType(header).toLowerCase();

				return result;
			}
		};

		this.translateRow = function(row) {
			if (data) {
				var output = {};
				output.rolledUpFields = [];
				_.each(data.header, function(header, i) {
					output[headerHash(header)] = row[i];
					if (!header.aggregation && header.columnType !== 'COUNT') {
						if (header.fieldId) {
							output.rolledUpFields.push({
								fieldId: header.fieldId,
								value: row[i]
							});
						} else if (header.segmentId) {
							output.rolledUpFields.push({
								segmentId: header.segmentId,
								value: row[i]
							});
						} else if (header.function) {
							output.rolledUpFields.push({
								function: header.function,
								funcArguments: header.funcArguments,
								value: row[i]
							});
						}
					}
				});

				return output;
			}
		};

		this.columns = function() {
			return _.map(data.header, this.translateHeader);
		};

		this.rows = function() {
			return _.map(data.rows, this.translateRow);
		};

		this.data = function() {
			return data;
		};

		this.formattedData = function() {

			var formatters = _.map(data.header, function(header) {
				return FormatFactory.formatterForType(actualType(header), formatOptions(header));
			});

			return {
				header: data.header,
				rows: _.map(data.rows, function(row) {
					return _.map(row, function(datum, i) {
						return formatters[i](datum);
					});
				})
			};
		};

		this.unformattedData = function() {
			return {
				header: data.header,
				rows: _.map(data.rows, function(row) {
					return _.map(row, function(datum) {
						return datum;
					});
				})
			};
		};

		this.c3Data = function() {
			var measuresOnly = function(x, i) {
				return isColumnAtIndexConsideredAMeasure(i);
			};

			var wrapInArray = function(val) {
				return [val];
			};

			var unformattedData = this.unformattedData();
			var groups = _.chain(unformattedData.header).filter(measuresOnly).pluck('name').map(wrapInArray).value();

			var columnValues = _.map(measureColumnIndexes, function(index) {
				var title = unformattedData.header[index].asName || unformattedData.header[index].title || unformattedData.header[index].name;

				return [title].concat(_.pluck(unformattedData.rows, index));
			});

			var columnHeaders = ['x'].concat(this.categories());

			var c3Data = {
				columns: [columnHeaders].concat(columnValues),
				groups: groups
			};

			for (var i = 0; i < data.header.length; i++) {
				if (data.header[i].aggregation) {
					c3Data.options = formatOptions(data.header[i]);
					c3Data.options.dataType = data.header[i].type;
				}
			}

			return c3Data;

		};

		/**
		 * Format the results so they can be rendered as a scatter plot.
		 */
		this.scatterPlotData = function() {
			var x = measureColumnIndexes[0],
				y = measureColumnIndexes[1],
				r = measureColumnIndexes[2] || undefined,
				unformattedData = this.unformattedData(),
				radii = [], // array of all scatter point values
				rTitle = ''; // title of the measure used for the radius

			// use the first two measures as the values for the x and y axis
			var columnValues = _.map([x, y], function(index) {
				var title = unformattedData.header[index].name;
				return [title].concat(_.pluck(unformattedData.rows, index));
			});

			// if there is a third measure, use it to compute the radius of the point.
			if (r !== undefined) {
				radii = _.pluck(unformattedData.rows, r);
				rTitle = unformattedData.header[r].title;
			}

			// compute the labels to put on the tooltips
			var categories = this.categories();

			// Get options so we can format the data within C3
			var options = {};
			for (var i = 0; i < data.header.length; i++) {
				if (data.header[i].aggregation) {
					options = formatOptions(data.header[i]);
					options.dataType = data.header[i].type;
				}
			}

			return {
				columns: columnValues,
				x: columnValues[0][0],
				categories: categories,
				r: radii,
				rTitle: rTitle,
				options: options
			};
		};

		/**
		 * Format the results so they can be rendered as a stacked bar chart.
		 */
		this.stackedBarData = function(positiveGroupName, negativeGroupName, sortOrder) {
			var y = groupedColumnIndexes[0],
				m = measureColumnIndexes[0],
				positiveValues = [positiveGroupName],
				negativeValues = [negativeGroupName];

			// first, sort the data by the measure
			this.sort(y, sortOrder);

			// set categories
			var categoryValues = ['Total'].concat(this.categories());

			// now, figure out the total of all records.  we use this as our starting point for the funnel.
			var total = _.reduce(_.chain(data.rows).pluck(m).value(), function(memo, num) {
				return memo + num;
			}, 0);

			// push a totals row onto the top of the funnel
			positiveValues.push(total);
			negativeValues.push(0);

			// now, for each value, calculate the positive and negative column value.  The negative
			// value is computed by taking the difference between the current column value and the
			// previous column value.
			_.each(data.rows, function(val) {
				total = total - val[m];

				positiveValues.push(total);
				negativeValues.push(-val[m]);
			});

			// lastly, we need to manipulate the last row in the result set.  The negative value should become
			// the positive value so the funnel looks like it has a positive outcome.
			var lastValueIndex = positiveValues.length - 1;
			positiveValues[lastValueIndex] = -1 * negativeValues[lastValueIndex];
			negativeValues[lastValueIndex] = 0;

			return {
				columns: [
					positiveValues,
					negativeValues
				],
				categories: categoryValues,
				groups: [
					[positiveGroupName, negativeGroupName]
				]
			};
		};

		/**
		 * Generate data suitable for display as a pie chart.
		 */
		this.pieData = function() {
			var unformattedData = this.unformattedData();
			var columns = this.categories();
			var columnValues = this.measures(0); // always use the first measure

			var chartData = [];
			for (var i = 0; i < columns.length; i++) {
				if (isNaN(columnValues[i])) {
					columnValues[i] = unformattedData.rows[i][1];
				}
				chartData[i] = [columns[i], columnValues[i]];
			}

			return chartData;
		};

		this.donutData = function() {
			var unformattedData = this.unformattedData(),
				chartData = [],
				row = {},
				col = '';

			// Each row
			for (var i = 0; i < unformattedData.rows.length; i++) {
				row = {};
				col = '';

				// Each column
				for (var j = 0; j < unformattedData.header.length; j++) {
					if (unformattedData.header[j].columnType === 'FUNCTION' && unformattedData.header[j].function === 'elapsedtime') {
						col = 'column_' + unformattedData.header[j].function;
						col += '_';
						var fields = _.pluck(unformattedData.header[j].funcArguments, 'fieldId').join('_');
						col += fields;
					} else {
						col = 'column_' + unformattedData.header[j].fieldId;
					}

					if (unformattedData.header[j].function && unformattedData.header[j].function !== 'elapsedtime') {
						col = 'column_' + unformattedData.header[j].function;
					}

					if (unformattedData.header[j].segmentId) {
						col = 'column_' + unformattedData.header[j].segmentId;
					}

					if (unformattedData.header[j].aggregation) {
						col += '_' + unformattedData.header[j].aggregation;
					}

					row[col] = unformattedData.rows[i][j];
				}
				chartData.push(row);
			}

			return chartData;
		};

		this.pivot = function() {
			var x, y, m,
				categorySortDirection,
				seriesSortDirection,
				categories,
				categoryTotals = 0,
				series,
				categoriesFormat,
				seriesFormat,
				dataFormat;

			y = groupedColumnIndexes[0];
			x = groupedColumnIndexes[1];
			m = measureColumnIndexes[0];

			if (data.header[x] && data.header[y]) {
				categorySortDirection = (data.header[x].sort || {}).order;
				seriesSortDirection = (data.header[y].sort || {}).order;

				categories = _.chain(data.rows).pluck(x).unique().value().sort(comparator(categorySortDirection));

				categoryTotals = _.map(categories, _.constant(0));

				series = _.chain(data.rows).pluck(y).unique().sort(comparator(seriesSortDirection)).map(function(title) {
					return {
						title: title,
						collection: new Collection(_.map(categories, function(category) {
							return {
								name: category,
								value: null
							};
						})),
						total: 0
					};
				}).value();

				_.each(data.rows, function(row) {
					var value = row[m];
					var s = _.findWhere(series, {
						title: row[y]
					});
					var categoryIndex = _.indexOf(categories, row[x]);

					s.collection.at(categoryIndex).set('value', value);
					s.total += value;
					categoryTotals[categoryIndex] += value;


				});
			}

			categoriesFormat = FormatFactory.formatterForType(actualType(data.header[x]), formatOptions(data.header[x]));
			seriesFormat = FormatFactory.formatterForType(actualType(data.header[y]), formatOptions(data.header[y]));
			dataFormat = FormatFactory.formatterForType(actualType(data.header[m]), formatOptions(data.header[m]));

			return {
				categories: categories,
				series: series,
				categoryTotals: categoryTotals,
				categoriesFormat: categoriesFormat,
				seriesFormat: seriesFormat,
				dataFormat: dataFormat
			};
		};

		this.categories = function() {
			return _.map(data.rows, function(columns) {
				var groupedColumns = [];

				_.each(groupedColumnIndexes, function(i) {
					var format = FormatFactory.formatterForType(actualType(data.header[i]), formatOptions(data.header[i]));
					groupedColumns.push(format(columns[i]));
				});

				return groupedColumns.join(' - ');
			});
		};

		this.measures = function(n) {
			if (n !== undefined) {
				return this.measures()[n];
			}

			var result = _.map(measureColumnIndexes, function(index) {
				return _.map(data.rows, function(row) {
					var format = FormatFactory.formatterForType(actualType(data.header[index]), formatOptions(data.header[index]));
					return format(row[index]);
				});
			});
			return result;
		};

		this.series = function(n) {

			if (measureColumnIndexes.length < n + 1) {
				return {
					title: 'No series found at index ' + n,
					dataType: 'NO_DATA',
					collection: []
				};
			}

			var result = {
				title: data.header[measureColumnIndexes[n]].name,
				collection: new Collection(_.map(_.zip(this.categories(), this.measures(n)), function(tuple) {
					return {
						name: tuple[0],
						value: tuple[1]
					};
				})),
				type: actualType(data.header[measureColumnIndexes[n]])
			};
			return result;
		};

		this.firstSortPriority = function() {
			var headersWithSort = _.filter(data.header, function(header) {
				return _.isObject(header.sort) && _.isNumber(header.sort.priority);
			});
			return _.min(_.map(headersWithSort, function(header) {
				return header.sort.priority;
			}));
		};

		this.hasCategoriesAndMeasures = function() {
			return this.categories().join('') !== '' && this.measures().length > 0;
		};

		this.recordCount = function() {
			return data.rows.length;
		};

		this.kpi = function() {
			//find the index of the first 'isMeasure' column
			var index = -1;
			for (var i = 0; i < data.header.length; i++) {
				if (data.header[i].isMeasure) {
					index = i;
					break;
				}
			}
			//create kpi object response
			var hdr = data.header[index];
			return {
				type: actualType(hdr),
				value: data.rows[0][index],
				format: FormatFactory.formatterForType(actualType(hdr), formatOptions(hdr)),
				toString: function() {
					return this.format(this.value);
				}
			};
		};

		this.categoryCount = function() {
			return _.filter(this.columns(), function(col) {
				return col.metadata.name !== 'primaryColumn' && !col.metadata.aggregation;
			}).length;
		};

		this.measureCount = function() {
			return measureColumnIndexes.length;
		};

		this.sort = function(index, direction) {
			if (!data || !data.header || !data.header[index]) {
				return;
			}

			data.header[index].sort = data.header[index].sort || {};
			data.header[index].sort.order = (direction || 'asc').toUpperCase();

			if (direction.toLowerCase() === 'desc') {
				data.rows.sort(function(a, b) {
					return descendingCaseInsensitiveComparator(a[index], b[index]);
				});

			} else {
				data.rows.sort(function(a, b) {
					return ascendingCaseInsensitiveComparator(a[index], b[index]);
				});

			}
		};

		this.rearrangeHeaders = function(headers) {
			var newPositionMap = [];
			var translatedPositions = {};
			_.each(headers, function(h, i) {
				newPositionMap[i] = headerHash(h);
			});

			_.each(data.header, function(h, i) {
				translatedPositions[headerHash(h)] = i;
			});

			data.header = headers;
			data.rows = _.map(data.rows, function(row) {
				return _.map(row, function(c, i) {
					return row[translatedPositions[newPositionMap[i]]];
				});
			});

			findMeasureColumnIndexes();
			findGroupedColumnIndexes();
		};

	};

});

